module.exports = __webpack_public_path__ + "static/media/rajapinta.f6d2ce45.png";